// Request actions that run through the cashier branch-change workflow
// (review -> application e-mails -> confirmations -> finalization).
// Mirrors lud-backend/services/branchWorkflow/lifecycle.js.
export const BRANCH_ACTIONS = ["updateBranchHours", "maintenanceClosure"];
export const isBranchAction = (action) => BRANCH_ACTIONS.includes(action);
